<template>
    <div class="max-w-screen-2xl w-full mx-auto">

        <div class="grid md:grid-cols-4 gap-3">
            <div class="md:col-span-2 flex flex-col md:order-0 order-1">
                <div v-if="$slots.top" class="bg-white rounded-md shadow-md w-full lg:p-8 p-4 mb-3">
                    <slot name="top"/>
                </div>
                <div v-if="$slots.address" class="bg-white text-gray-900 rounded-md shadow-md lg:p-8 p-4 mb-3">
                    <h2 class="border-b-2 border-red-700 pb-4 mb-4 text-xl font-bold">{{__('Billing Address')}}</h2>
                    <slot name="address"/>
                </div>
                <div v-if="$slots.payments" class="bg-white text-gray-900 rounded-md shadow-md lg:p-8 p-4">
                    <h2 class="border-b-2 border-red-700 pb-4 mb-4 text-xl font-bold">{{__('Payments')}}</h2>
                    <slot name="payments"/>
                </div>
            </div>
            <div class="md:col-span-2 flex flex-col md:order-1 order-0">
                <div v-if="$slots.cart" class="bg-white text-gray-900 rounded-md shadow-md sticky top-20 lg:p-8 p-4 flex flex-col">
                    <h2 class="border-b-2 border-red-700 pb-4 mb-4 text-xl font-bold">{{__('Shopping cart')}}</h2>
                    <slot name="cart"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Steps from 'STEPS/Container';
import StepItem from 'STEPS/Item';

import Button from 'UI/Button';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Button,
        Steps,
        StepItem
    },
    props: {
        step: Number,
    },
}
</script>
